import { Modal as ModalComponent } from '@arionbanki/arionui';

export const Modal: any = ModalComponent;
